import { useContext } from 'react';
import { ReferenceAliasContext } from '@/context/ReferenceAliasContext';

export function useReferenceAlias() {
  return useContext(ReferenceAliasContext);
}
